var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentBalloon1616 = function SvgCommentBalloon1616(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "comment_balloon_16_16_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#comment_balloon_16_16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A0C0FF",
    d: "M13.85 10.683q.316-.683.474-1.4.159-.717.159-1.467 0-1.383-.525-2.6A6.7 6.7 0 0 0 12.533 3.1a6.7 6.7 0 0 0-2.117-1.425 6.5 6.5 0 0 0-2.6-.525q-1.383 0-2.6.525A6.7 6.7 0 0 0 3.1 3.1q-.9.9-1.425 2.116a6.5 6.5 0 0 0-.525 2.6q0 1.385.525 2.6.525 1.217 1.425 2.117t2.117 1.425 2.6.525a6.8 6.8 0 0 0 2.867-.633l3.3.966a.62.62 0 0 0 .666-.166.62.62 0 0 0 .167-.667z"
  }))));
};
export default SvgCommentBalloon1616;